export default __webpack_public_path__ + "static/media/SAL6.7e47cae2.jpg";